module.exports = __webpack_public_path__ + "img/04钱敏.1a0bd3ec.jpg";